// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListItemTitle_wrapper__1dc_O","name":"ListItemTitle_name__2sigm","companyName":"ListItemTitle_companyName__3uQYo"};